export default import.meta.ROLLUP_FILE_URL_NFBwAzOFQkuWT4yYmw9Nag